module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.989954c1.woff2";